import api from './api';

class AuthService {
  // Login de usuario
  async login(credentials) {
    try {
      const response = await api.post('/auth/login', credentials);
      
      // Verificar si requiere cambio de contraseña
      if (response.data.challenge === 'NEW_PASSWORD_REQUIRED') {
        localStorage.setItem('userInfo', JSON.stringify(response.data.user));
        return {
          challenge: 'NEW_PASSWORD_REQUIRED',
          session: response.data.session,
          message: response.data.message,
          cognito_id: response.data.user.id,
          user: response.data.user,
        };
      }
      // Guardar tokens en localStorage
      if (response.data.accessToken) {
        localStorage.setItem('accessToken', response.data.accessToken);
        localStorage.setItem('refreshToken', response.data.refreshToken);
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('tokenExpiresIn', response.data.expiresIn);
        localStorage.setItem('tokenType', response.data.tokenType);
      }
      
      if (response.data.user) {
        localStorage.setItem('userInfo', JSON.stringify(response.data.user));
      }
      
      return response.data;
    } catch (error) {
      console.error('Error during login:', error);
      throw error;
    }
  }

  // Logout de usuario
async logout() {
  try {
    // Llamar al endpoint de logout
    await api.post('/auth/logout', { accessToken: localStorage.getItem('accessToken') });
  } catch (error) {
    console.error('Error during logout:', error);
    // Continuar con el logout local aunque falle la llamada al servidor
  } finally {
    // Limpiar todos los datos locales
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('token');
    localStorage.removeItem('tokenExpiresIn');
    localStorage.removeItem('tokenType');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('accessToken');
  }
}

  // Cambiar contraseña del usuario actual
  async changePassword(passwordData) {
    try {
      const response = await api.post('/auth/change-password', passwordData);
      // Actualizar tokens en localStorage si se reciben
      if (response.data.accessToken) {
        localStorage.setItem('accessToken', response.data.accessToken);
        localStorage.setItem('refreshToken', response.data.refreshToken);
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('tokenExpiresIn', response.data.expiresIn);
        localStorage.setItem('tokenType', response.data.tokenType);
      }

      return response.data;
    } catch (error) {
      console.error('Error changing password:', error);
      throw error;
    }
  }

  // Verificar si el usuario está autenticado
  isAuthenticated() {
    try {
      const token = localStorage.getItem('accessToken');
      const userInfo = localStorage.getItem('userInfo');
  
      if (!token || !userInfo) {
        return false;
      }
  
      if (this.isTokenExpired()) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('token');
        localStorage.removeItem('tokenExpiresIn');
        localStorage.removeItem('tokenType');
        localStorage.removeItem('userInfo');
        return false;
      }
  
      return true;
    } catch (error) {
      console.error('Error in isAuthenticated:', error);
      return false;
    }
  }

  // Obtener información del usuario actual
  getCurrentUser() {
    const userInfo = localStorage.getItem('userInfo');

    if (!userInfo) {
      return null;
    }

    try {
      return JSON.parse(userInfo);
    } catch (error) {
      console.error('Error parsing user info:', error);
      return null;
    }
  }

  // Obtener el token de autenticación
  getToken() {
    return localStorage.getItem('accessToken');
  }

  // Verificar si el token ha expirado
  isTokenExpired() {
    const token = this.getToken();
    if (!token) return true;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      const isExpired = payload.exp < currentTime;

      return isExpired;
    } catch (error) {
      return true;
    }
  }

  async refreshToken() {
    try {
      const token = this.getToken();
      if (!token) return false;

      // Verificar si el token está por expirar (5 minutos antes)
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      const timeUntilExpiry = payload.exp - currentTime;

      if (timeUntilExpiry < 300) { // 5 minutos
        // Token expirará pronto, intentar renovar
        const response = await api.post('/auth/refresh');
        if (response.data.token) {
          localStorage.setItem('accessToken', response.data.token);
          localStorage.setItem('userInfo', JSON.stringify(response.data.user));
          return true;
        }
      }

      return true;
    } catch (error) {
      return false;
    }
  };

}

const authService = new AuthService();

export default authService;